import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { HelperService } from './helper.service';


@Injectable({
    providedIn: 'root'
})
export class DataService {

    constructor(
        private http: Http,
        public helperService: HelperService
    ) { }

    // private apiURL: string = "http://localhost:3000/api/";
    private apiURL: string = "https://wausaultra.uc.r.appspot.com/api/";
    // public appMode: string = "viewer"; // "manager" - // !!! TODO: this needs to be manager on the locally running machine !!!
    public appMode: string = "viewer";

    /**
     * Build a prototype of the backyard2021 race document here, to ensure everything needed is there before building into the database.
     * @type {[{}]}
     */
    public endRaceCounter = 0;
    public raceProfiles: any = {
        backyard2021: {
            eventName: "Backyard Ultra",
            docType: "event",
            eventId: "backyard2021",
            startTime: "2021-04-30T15:00:00.000Z",
            finishTime: "",
            timeElapsed: "",
            timeElapsedMS: 0,
            format: 'backyard',
            lapCounter: 0,
            lapDistance: 4.167, // in miles
            lapElevation: 516, // in feet
            lapIncrementDuration: 1000 * 60 * 60, // (10 minutes for testing...) 1 hour in milliseconds
            lapTimeRemaining: "",
            lapTimeRemainingMS: 0,
            lapFinish: 999,
            lapCompletedRacers: [], // how many racers have completed the current lap
            racersCheckedInCount: 0, // count of signed up people on the course and ready to start
            totalRacersInEvent: 0, // count of people signed up for the race
            racersOnCourse: [] // how many people are still out on the course this lap
        },
        backyard2022: {
            eventName: "Backyard Ultra",
            docType: "event",
            eventId: "backyard2022",
            startTime: "2022-04-29T15:00:00.000Z", // TODO: run through this at least once more tomorrow with more racers.
            finishTime: "",
            timeElapsed: "",
            timeElapsedMS: 0,
            format: 'backyard',
            lapCounter: 0,
            lapDistance: 4.167, // in miles
            lapElevation: 516, // in feet
            lapIncrementDuration: 1000 * 60 * 60, // (10 minutes for testing...) 1 hour in milliseconds
            lapTimeRemaining: "",
            lapTimeRemainingMS: 0,
            lapFinish: 999,
            lapCompletedRacers: [], // how many racers have completed the current lap
            racersCheckedInCount: 0, // count of signed up people on the course and ready to start
            totalRacersInEvent: 0, // count of people signed up for the race
            racersOnCourse: [] // how many people are still out on the course this lap
        },
        backyard2023: {
            eventName: "Backyard Ultra",
            docType: "event",
            eventId: "backyard2023",
            startTime: "2023-04-28T15:00:00.000Z",
            finishTime: "",
            timeElapsed: "",
            timeElapsedMS: 0,
            format: "backyard",
            lapCounter: 0,
            lapDistance: 4.167,
            lapElevation: 516,
            lapIncrementDuration: 1000 * 60 * 60, // (10 minutes for testing...) 1 hour in milliseconds
            lapTimeRemaining: "",
            lapTimeRemainingMS: 0,
            lapFinish: 999,
            lapCompletedRacers: [], // how many racers have completed the current lap
            racersCheckedInCount: 0, // count of signed up people on the course and ready to start
            totalRacersInEvent: 0, // count of people signed up for the race
            racersOnCourse: [] // how many people are still out on the course this lap
        },
        doubleDown2021: { // hold off on this for a bit - may just build out for the backyard and time the double down separately
            eventName: "Double Down",
            docType: "event",
            eventId: "doubleDown2021",
            startTime: "2021-05-01T15:30:00.000Z",
            timeElapsed: "",
            timeElapsedMS: 0,
            format: 'heat',
            lapCounter: 0,
            lapDistance: 4.167,
            lapElevation: 618,
            lapIncrementDuration: 1000 * 60 * 75, // 1 hour 15 minutes in milliseconds
            lapTimeRemaining: "",
            lapTimeRemainingMS: 0,
            lapFinish: 2,
            lapCompletedRacers: [],
            racersCheckedInCount: 0,
            racersOnCourse: []
        },
        doubleDown2022: { // hold off on this for a bit - may just build out for the backyard and time the double down separately
            eventName: "Double Down",
            docType: "event",
            eventId: "doubleDown2022",
            startTime: "2022-04-30T15:30:00.000Z",
            timeElapsed: "",
            timeElapsedMS: 0,
            format: 'heat',
            lapCounter: 0,
            lapDistance: 4.167,
            lapElevation: 618,
            lapIncrementDuration: 1000 * 60 * 75, // 1 hour 15 minutes in milliseconds
            lapTimeRemaining: "",
            lapTimeRemainingMS: 0,
            lapFinish: 2,
            lapCompletedRacers: [],
            racersCheckedInCount: 0,
            racersOnCourse: []
        },
        doubleDown2023: { // hold off on this for a bit - may just build out for the backyard and time the double down separately
            eventName: "Double Down",
            docType: "event",
            eventId: "doubleDown2023",
            startTime: "2023-04-29T15:30:00.000Z",
            timeElapsed: "",
            timeElapsedMS: 0,
            format: 'heat',
            lapCounter: 0,
            lapDistance: 4.167,
            lapElevation: 618,
            lapIncrementDuration: 1000 * 60 * 75, // 1 hour 15 minutes in milliseconds
            lapTimeRemaining: "",
            lapTimeRemainingMS: 0,
            lapFinish: 2,
            lapCompletedRacers: [],
            racersCheckedInCount: 0,
            racersOnCourse: []
        }
    };
    public currentBackyardId: string = "backyard2023";
    public currentDDId: string = "doubleDown2023";
    public currentYearBackyardRacers: any[];
    public currentYearDoubleDownRacers: any[];
    public racers: any = [];
    public raceStarted: boolean = false;
    public raceFinished: boolean = false;
    // keeping a running list of laps entries here for future modification if needed.
    public completedLaps: any = [
        // {
        //     lapTime: "-",
        //     division: "-",
        //     firstName: "",
        //     lastName: "",
        //     bibNumber: null,
        //     raceId: ""
        // }
    ];
    public lapCounting: any = [];

    public getAllRacers(){
        let scope = this;
        // console.log("Trying to get all the racers from -> "+this.apiURL+"GetAllRacers/");
      // this will return ALL racers - regardless of year or event - filters to come - or filter on page, as there aren't that many.
        this.http.get(this.apiURL+"GetAllRacers/").subscribe((res: any) => {
            // console.log(res);
            let data = JSON.parse(res["_body"]);
            if (data.error){
                // console.log("error getting the racer documents from the database");
                // console.log(data.message);
            } else {
                // assign all racers array
                scope.racers = data.message;

                // lets get the racers for the scope.currentBackyardId loaded into the currentyearBackyardRacers
                scope.setCurrentYearRacers();

                // console.log(data);
                // default the initial pull to sort by bibNumber
                scope.racers.sort(function (a, b) {
                    if (a[scope.currentBackyardId] && b[scope.currentBackyardId]) {
                        return parseInt(a[scope.currentBackyardId].bibNumber) - parseInt(b[scope.currentBackyardId].bibNumber);
                    } else if (a[scope.currentBackyardId] && !b[scope.currentBackyardId]) {
                        return -1;
                    } else if (!a[scope.currentBackyardId] && b[scope.currentBackyardId]) {
                        return 1;
                    } else {
                        return -1;
                    }
                });
                // sort the current year of racers by bib number
                scope.currentYearBackyardRacers.sort(function (a, b) {
                    return parseInt(a[scope.currentBackyardId].bibNumber) - parseInt(b[scope.currentBackyardId].bibNumber);
                });
                // console.log(scope.racers);
            }
            if (scope.raceStarted){
                // this is to establish a refresh of live data for the leaderboard only display
                // console.log("the race is running, refresh the racers every 5 minutes");
                setTimeout(function(){
                    scope.getAllRacers();
                }, 5 * 60 * 1000)
            }
        });
        if (!scope.raceStarted){
            let now = new Date();
            if (Date.parse(now.toISOString()) > Date.parse(this.raceProfiles[this.currentBackyardId].startTime)){
                scope.raceStarted = true;
                // console.log("the race has started -> refresh the racers data after 5 minutes");
                setTimeout(function(){
                    scope.getAllRacers();
                }, 5 * 60 * 1000);
            }
        }
    }

    public createRacer(racerDoc){
        return this.http.post(this.apiURL+"CreateRacer/", racerDoc);
    }

    public updateRacer(email, updates){
        // console.log("update racer request for email: "+email+" and updates -> ");
        // console.log(updates);
        return this.http.post(this.apiURL+"UpdateRacer/", {email: email, updates: updates});
    }

    public completeRacerLap(email, updates){
        return this.http.post(this.apiURL+"UpdateRacer/", {email: email, updates: updates});
    }

    public endRacer(racerDoc){
        // complete this function yet.
        // console.log('racer wants out yo.');
    }

    public startRace(id) {
       
        if (!this.raceStarted) {
            this.raceStarted = true;
            // locate all 'checked in' racers and start them off
            console.log("Starting RaceID: " + id);
            if (this.appMode == "manager"){
                for (let r = 0; r < this.racers.length; r++) {
                    if (this.racers[r][id]) {
                        if (this.racers[r].checkedIn && this.racers[r][id].registered) {
                            console.log("Racer: " + this.racers[r].firstName + " is starting.");
                            this.raceProfiles[id].racersStillCompeting++;
                            // un-set any previous laps for this race to start tracking.
                            this.racers[r].laps = [{ lap: 1, started: new Date() }];
                            let updates = { "laps": this.racers[r].laps };
                            this.completeRacerLap(this.racers[r].email, updates).subscribe((res: any) => { });
                        }
                    }
                }
            }
        }
    }

    // this needs to update to accurate numbers for races that are not started and ran in memory the entire time - dynamic object.
    public onGoingRace(id){

        let now = new Date();
        if (!this.raceStarted){
            // console.log('setting the race as started');
            this.raceStarted = true;
        }
        this.raceProfiles[id].timeElapsedMS = Date.parse(now.toISOString()) - Date.parse(this.raceProfiles[id].startTime);
        this.raceProfiles[id].timeElapsed = this.helperService.friendlyTimeDuration(this.raceProfiles[id].timeElapsedMS, "ms");
        this.raceProfiles[id].lapCounter = Math.floor(this.raceProfiles[id].timeElapsedMS / this.raceProfiles[id].lapIncrementDuration);
        this.raceProfiles[id].lapTimeRemainingMS = Date.parse(now.toISOString()) - (Date.parse(this.raceProfiles[id].startTime) + (this.raceProfiles[id].lapCounter * this.raceProfiles[id].lapIncrementDuration));
        this.raceProfiles[id].lapTimeRemaining = this.helperService.friendlyTimeDuration(this.raceProfiles[id].lapTimeRemainingMS, "ms");
        // this.raceProfiles[id].lapTimeRemainingMS = this.lapTimeRemainingMS();
        // this.raceProfiles[id].lapTimeRemaining =  this.helperService.friendlyTimeDuration(this.raceProfiles[id].lapTimeRemainingMS, "ms");

        this.raceProfiles[id].racersOnCourse = []; // unset this before adding up.
        this.raceProfiles[id].lapCompletedRacers = [];

        for (let r = 0; r < this.racers.length; r++){
            if (this.racers[r][id]) {

                if (this.racers[r][id].registered && this.racers[r].laps[this.raceProfiles[id].lapCounter]) {
                    if (this.racers[r].laps[this.raceProfiles[id].lapCounter].started && !this.racers[r].laps[this.raceProfiles[id].lapCounter].completed) {

                        this.raceProfiles[id].racersOnCourse.push(this.racers[r][id].bibNumber);
                    }
                    if (this.racers[r].laps[this.raceProfiles[id].lapCounter].started && this.racers[r].laps[this.raceProfiles[id].lapCounter].completed) {
                        this.raceProfiles[id].lapCompletedRacers.push(this.racers[r][id].bibNumber);
                    }
                }
            }
        }

        // Trigger the next lap when needed
        if (this.lapCounting.length < this.raceProfiles[this.currentBackyardId].lapCounter){
            this.lapCounting.push(this.raceProfiles[this.currentBackyardId].lapCounter - 1);
            // console.log(this.raceProfiles.backyard2021);
            // console.log(this.lapCounting);
        // if (this.lapTimeRemainingMS() <= 0){
            // start off all racers who have finished the previous lap
            // console.log('trigger the next lap!');
            this.completedLaps = [];
            let racersStartedThisLapCount = 0;
            for (let r = 0; r < this.racers.length; r++){
                if (this.racers[r].laps[this.racers[r].laps.length - 1]){
                    if (this.racers[r].laps[this.racers[r].laps.length - 1].completed){
                        // console.log("passed checks -> start racer "+this.racers[r].firstName+" on the next lap.");
                        // ensure it is the correct lap
                        if (this.racers[r].laps[this.racers[r].laps.length - 1].lap == this.raceProfiles[id].lapCounter){
                            // console.log("matched the racer lap to the racer lap, starting the racer out....");
                            // start them on the next lap.
                            this.raceProfiles.backyard2021.racersOnCourse.push(this.racers[r][this.currentBackyardId].bibNumber);
                            this.racers[r].laps.push({lap: (this.raceProfiles[id].lapCounter + 1), started: new Date()});
                            racersStartedThisLapCount++;
                            if (this.appMode == "manager") {
                                let updates = {"laps": this.racers[r].laps};
                                this.completeRacerLap(this.racers[r].email, updates).subscribe((res: any) => {
                                });
                            }
                        } else {
                            // console.log("racer did not start lap "+this.raceProfiles[id].lapCounter);
                        }
                    }
                }
            }
        }
        /**
        if (this.raceProfiles[id].lapCounter == this.raceProfiles[id].lapFinish) {
            //  todo: determine how to stop the race when there is no one left racing.
            console.log("RACE IS OVER --- lap counter = lap finish ");
            this.raceFinished = true;
            this.raceStarted = false;
            // todo: write a script to end the event.
        } else if (this.raceProfiles[id].racersOnCourse.length == 0 && this.raceProfiles[id].lapCompletedRacers.length == 0) {
            console.log("ok - can we end the race now ?? -- racersoncourse " + this.raceProfiles[id].racersOnCourse.length + " -> lapCompletedRacers " + this.raceProfiles[id].lapCompletedRacers.length);
            this.raceFinished = true;
            this.raceStarted = false;
        } else {
            this.raceFinished = false;
        }
        */
    }

    public lapTimeRemainingMS(){
        // this is coming through as a negative number... / todo: investigate this.
        // STILL PRODUCING NEGATIVE!!!
        // let now = new Date();
        let id = this.currentBackyardId;
        let now = new Date();
        let lapCounter = this.raceProfiles[id].lapCounter;
        if (this.raceProfiles[id].lapCounter == 0){
            // set the lapCounter to how every many full hours the race has been running.
            let duration = Date.parse(now.toISOString()) - Date.parse(this.raceProfiles[id].startTime);
            let hoursRaw = duration / this.raceProfiles[id].lapIncrementDuration;
            lapCounter = Math.floor(hoursRaw);
        }
        // console.log(Date.parse(now.toISOString()));
        let lapTimeRemainingMS = this.raceProfiles[id].lapIncrementDuration - (Date.parse(now.toISOString()) - (Date.parse(this.raceProfiles[id].startTime) + (lapCounter * this.raceProfiles[id].lapIncrementDuration)));
        return lapTimeRemainingMS;
        // this.raceProfiles[id].lapTimeRemaining = this.helperService.friendlyTimeDuration(this.raceProfiles[id].lapTimeRemainingMS, "ms");
        // return this.raceProfiles.backyard2021.lapTimeRemainingMS;
        // return ( (this.raceProfiles.backyard2021.lapCounter + 1) * this.raceProfiles.backyard2021.lapIncrementDuration) - (Date.parse(new Date().toISOString()) - (Date.parse(this.raceProfiles.backyard2021.startTime) ));
    }

    public completeLap(racerDoc, lap){
        // console.log('racer current lap object');
        // console.log(racerDoc.laps[racerDoc.laps.length - 1]); // show current lap
        // match the incoming lap.lapNumber to the racerDoc.laps[x].lapNumber - throw error if there is not a match.
        //     if the current lap number was already set as completed, DO NO OVERWRITE
        if (racerDoc.laps[this.raceProfiles[this.currentBackyardId].lapCounter]){
            if (racerDoc.laps[this.raceProfiles[this.currentBackyardId].lapCounter].completed){
                alert("ERROR CASE HERE - RACER HAS ALREADY COMPLETED THIS LAP");
                // todo: determine feedback to the user here yet.
                return false;
            }
        }
        racerDoc.laps[racerDoc.laps.length - 1].completed = new Date();
        racerDoc.laps[racerDoc.laps.length - 1].lapDuration = Date.parse(racerDoc.laps[racerDoc.laps.length - 1].completed) - Date.parse(racerDoc.laps[racerDoc.laps.length - 1].started);
        if (this.appMode == "manager"){
            this.completeRacerLap(racerDoc.email, {laps: racerDoc.laps}).subscribe((res: any) => {});
        }
    }

    private setCurrentYearRacers() {
        this.currentYearBackyardRacers = this.racers.filter(e => e[this.currentBackyardId])
    }
}
